import React, { useState } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import EventParticipation from 'components/admin/reports/EventParticipation';
import { exportEventParticipationReportToFile } from 'api/reportsApi';
import { useSelector } from 'react-redux';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import { exportAndDownloadFile } from 'utils/fileDownload';

const EventParticipationPage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [reportData, setReportData] = useState(null);
  // true: count only meets that count for season points (default); false: every meet with results
  const [pointsEligibleOnly, setPointsEligibleOnly] = useState(true);

  const handleExportToFile = async () => {
    await exportAndDownloadFile(
      exportEventParticipationReportToFile,
      [selectedClub.clubID, pointsEligibleOnly],
      '',
      'The event participation report was successfully exported',
      'Fetching event participation data from the server...'
    );
  };

  const handleMeetScopeChange = (e) => {
    setPointsEligibleOnly(e.target.value === 'true');
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  // Get season name for subtitle
  const seasonSubtitle = reportData?.season?.seasonName || '';

  return (
    <>
      <MetaTags title="SplitFast | Event Participation Report" />
      <MainContent>
        <PageHeader title="Event Participation Report" subTitle={seasonSubtitle} primarySubTitle>
          <CustomNewButton
            variant="info"
            onClick={handleExportToFile}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>

        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <EventParticipation
            clubID={selectedClub?.clubID}
            onDataChange={setReportData}
            pointsEligibleOnly={pointsEligibleOnly}
            onMeetScopeChange={handleMeetScopeChange}
          />
        )}
      </MainContent>
    </>
  );
};

export default EventParticipationPage;
